export default {
    entityKey: 'deployment-account-groups',
    titles: {
        singular: 'Deployment Account Group',
        plural: 'Deployment Account Groups'
    }
}
